import createAsyncActions from 'store/_utils/createAsyncActions';
import { TMapEntitiesState } from './mapEntitiesModel';
import { EProtectedZone } from '../../../types';

export enum EMapEntitiesActions {
  ADD_ENTITY = 'mapEntities/ADD_ENTITY',
  REMOVE_ENTITY = 'mapEntities/REMOVE_ENTITY',
  UPDATE_DRAGGABLE_ENTITY = 'mapEntities/UPDATE_DRAGGABLE_ENTITY',

  ADD_LOCATION = 'mapEntities/ADD_LOCATION',
  CHECK_ZONE_INFO = 'mapEntities/CHECK_ZONE_INFO',
  CLOSE_ZONE_INFO = 'mapEntities/CLOSE_ZONE_INFO',

  FETCH_HIDDEN_VESSEL = 'mapEntities/FETCH_HIDDEN_VESSEL',
  FETCH_LOCATION_VALUE = 'mapEntities/FETCH_LOCATION_VALUE',
  FETCH_ZONE_DESCRIPTION = 'mapEntities/FETCH_ZONE_DESCRIPTION',
  HIDE_LOCATION_VALUE = 'mapEntities/HIDE_LOCATION_VALUE',
  REMOVE_VESSELS = 'mapEntities/REMOVE_VESSELS',
  RESET_STATE = 'mapEntities/RESET_STATE',
  PURGE_ENTITIES = 'mapEntities/PURGE_ENTITIES',
  SELECT_FARM = 'mapEntities/SELECT_FARM',
  SELECT_VESSEL = 'mapEntities/SELECT_VESSEL',
  SELECT_SERVICE = 'mapEntities/SELECT_SERVICE',
  UPDATE_ENTRIES_ON_DROP = 'mapEntities/UPDATE_ENTRIES_ON_DROP',
  UPDATE_ENTRIES_BY_TYPE = 'mapEntities/UPDATE_ENTRIES_BY_TYPE'
}

export const fetchSet = createAsyncActions<TMapEntitiesState>(
  EMapEntitiesActions.FETCH_HIDDEN_VESSEL
);

export const fetchLocationValueSet = createAsyncActions<TMapEntitiesState>(
  EMapEntitiesActions.FETCH_LOCATION_VALUE
);

export const fetchZoneDescriptionSet = createAsyncActions<TMapEntitiesState>(
  EMapEntitiesActions.FETCH_ZONE_DESCRIPTION
);

/**/
export const ZONES_WITH_INFO = [
  EProtectedZone.NO_PROTECTED_TCA,
  EProtectedZone.NO_PROTECTED_CCR,
  EProtectedZone.NO_PROTECTED_CCNG,
  EProtectedZone.NO_PROTECTED_PZS,
  EProtectedZone.NO_SEISMIC_ONGOING,
  EProtectedZone.NO_SEISMIC_PLANNED,
  EProtectedZone.SCOTTISH_MPA
];
